
import { NavItem, Service, Step, Testimonial } from './types';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Services', href: '#services' },
  { label: 'Process', href: '#process' },
  { label: 'About', href: '#about' },
  { label: 'Reviews', href: '#reviews' },
];

export const SERVICES: Service[] = [
  {
    icon: 'build',
    title: 'Roof Repair',
    description: "Precision leak detection and expert fixes for shingles, tile, and flat roofs to extend your roof's life.",
  },
  {
    icon: 'home',
    title: 'Full Replacement',
    description: 'Complete tear-offs and professional installation of high-efficiency roofing systems with lifetime warranties.',
  },
  {
    icon: 'architecture',
    title: 'Shingle & Tile',
    description: 'Specializing in Spanish tile and architectural shingles designed to withstand 150+ mph hurricane winds.',
  },
  {
    icon: 'thunderstorm',
    title: 'Storm Damage',
    description: 'Emergency 24/7 tarping and specialized insurance claim assistance following hail or tropical storms.',
  },
];

export const STEPS: Step[] = [
  {
    id: 1,
    title: 'Inspection',
    description: 'A comprehensive 50-point inspection of your roof, decking, and attic ventilation.',
  },
  {
    id: 2,
    title: 'Detailed Quote',
    description: 'No-nonsense, transparent pricing with choice of materials and financing options.',
  },
  {
    id: 3,
    title: 'Expert Installation',
    description: 'Factory-certified crews execute the job with daily cleanups and strict safety adherence.',
  },
  {
    id: 4,
    title: 'Quality Check',
    description: 'Final walk-through and site cleanup. Your warranty is registered and activated.',
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    text: "Margate Roofing handled our hurricane damage repair flawlessly. Their crew was fast, polite, and they even helped us navigate the insurance paperwork.",
    name: 'Sarah Johnson',
    location: 'Margate, FL',
    imageUrl: 'https://picsum.photos/seed/sarah/100/100',
  },
  {
    text: "Best roofing experience I've ever had. No hidden fees, the quote was exactly what I paid, and the new tile roof looks incredible. Highly recommend!",
    name: 'Robert Miller',
    location: 'Coconut Creek, FL',
    imageUrl: 'https://picsum.photos/seed/robert/100/100',
  },
  {
    text: "Professionalism at its finest. They finished my full shingle replacement in two days and left my yard spotless. Five stars!",
    name: 'David Chen',
    location: 'Coral Springs, FL',
    imageUrl: 'https://picsum.photos/seed/david/100/100',
  },
];
